// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Searchbar {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 1.2rem;
  cursor: pointer;
}
@media (min-width: 640px) {
  .Searchbar {
    margin-right: 2rem;
  }
}
.Searchbar--search {
  background-color: rgba(20, 20, 20, 0.25);
  border: 1px solid #f2f2f2;
  padding: 7px 30px 7px 7px;
  font-size: 12px;
  color: #f2f2f2;
  outline: none;
  border-radius: 6px;
  width: 0;
  opacity: 0;
  transition: all 0.2s ease-out;
}
@media (min-width: 640px) {
  .Searchbar--search {
    font-size: 14px;
  }
}
.Searchbar--search::-webkit-input-placeholder, .Searchbar--search::-moz-placeholder, .Searchbar--search::placeholder {
  color: #777777;
  opacity: 1;
}
.Searchbar--toggler {
  margin-left: 0.5rem;
}
.Searchbar--toggler svg {
  width: 1.3rem;
  height: 1.3rem;
}
@media (min-width: 640px) {
  .Searchbar--toggler svg {
    width: 1.5rem;
    height: 1.5rem;
  }
}
.Searchbar--clear {
  position: absolute;
  right: 18%;
  top: 55%;
  transform: translateY(-50%);
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
}
.Searchbar--clear.typing {
  opacity: 1;
  pointer-events: all;
  transition-delay: 0.1s;
}
.Searchbar--active {
  width: 160px;
  opacity: 1;
}
@media (min-width: 640px) {
  .Searchbar--active {
    width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/components/Searchbar/searchbar.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACFA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAIJ;ADgEQ;ECzER;IAQM,kBAAA;EAKJ;AACF;AAHI;EACE,wCAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,cCnBE;EDoBF,aAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;AAKN;AD+CQ;EC9DJ;IAaI,eAAA;EAMN;AACF;AAJM;EAGE,cAAA;EACA,UAAA;AAIR;AAAI;EACE,mBAAA;AAEN;AAAM;EACE,aAAA;EACA,cAAA;AAER;AD+BQ;ECnCF;IAKI,aAAA;IACA,cAAA;EAGR;AACF;AACI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,gCAAA;AACN;AACM;EACE,UAAA;EACA,mBAAA;EACA,sBAAA;AACR;AAGI;EACE,YAAA;EACA,UAAA;AADN;ADMQ;ECPJ;IAKI,YAAA;EAAN;AACF","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/mixin';\n@import '../../scss/variables';\n\n.Searchbar {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-right: 1.2rem;\n    cursor: pointer;\n\n    @include mq(sm) {\n      margin-right: 2rem;\n    }\n\n    &--search {\n      background-color: rgba($color: $black, $alpha: 0.25);\n      border: 1px solid $white;\n      padding: 7px 30px 7px 7px;\n      font-size: 12px;\n      color: $white;\n      outline: none;\n      border-radius: 6px;\n      width: 0;\n      opacity: 0;\n      transition: all 0.2s ease-out;\n\n      @include mq(sm) {\n        font-size: 14px;\n      }\n\n      &::-webkit-input-placeholder,\n      &::-moz-placeholder,\n      &::placeholder {\n        color: #777777;\n        opacity: 1;\n      }\n    }\n\n    &--toggler {\n      margin-left: 0.5rem;\n\n      svg {\n        width: 1.3rem;\n        height: 1.3rem;\n\n        @include mq(sm) {\n          width: 1.5rem;\n          height: 1.5rem;\n        }\n      }\n    }\n\n    &--clear {\n      position: absolute;\n      right: 18%;\n      top: 55%;\n      transform: translateY(-50%);\n      cursor: pointer;\n      opacity: 0;\n      pointer-events: none;\n      transition: all 0.2s ease-in-out;\n\n      &.typing {\n        opacity: 1;\n        pointer-events: all;\n        transition-delay: 0.1s;\n      }\n    }\n\n    &--active {\n      width: 160px;\n      opacity: 1;\n\n      @include mq(sm) {\n        width: 200px;\n      }\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
